import React from 'react';
import PropTypes from 'prop-types';
import {removeHTMLtags} from "../../../services/VariableTools";
import Education from "./Education";
import DateStart from "./DateStart";
import { getStyle } from '../../../services/Style';

export default class Summary extends React.PureComponent {

    static propTypes = {
        data: PropTypes.object.isRequired,
        language: PropTypes.string.isRequired,
		positionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
		customerName: PropTypes.string.isRequired,
	};

    render = () => {
        if (!this.props.data || ((!this.props.data.workMode || this.props.data.workMode.trim().length === 0) &&
            (this.props.data.practise === null || this.props.data.practise === undefined || this.props.data.practise <= 0) &&
            (!this.props.data.practise_sector || this.props.data.practise_sector.trim().length === 0) &&
            (!this.props.data.region_description || this.props.data.region_description.trim().length === 0) &&
            (!this.props.data.salary_text || this.props.data.salary_text.trim().length === 0) &&
            (!this.props.data.education || this.props.data.education.trim().length === 0) &&
            this.props.data.graduate !== 1 &&
            (!this.props.data.specialization || this.props.data.specialization.trim().length === 0) &&
            !this.props.data.date_start_type === 'date' &&
            !this.props.data.date_start
        )) {
            return null;
        }

        return (
            <div className="job-summary" style={getStyle(this.props.positionId, 'job-summary', this.props.customerName)}>
                <h4>{window.Translator.getSlug('Summary', this.props.language)}</h4>
                <ul>
                    {(this.props.data.workMode && this.props.data.workMode.trim().length !== 0) &&
                    <li>
                        <span>{window.Translator.getSlug('WorkMode', this.props.language)}:</span>{this.props.data.workMode}
                    </li>}
                    <Education education={this.props.data.education}
                               language={this.props.language}/>
                    {this.props.data.graduate === 1 && <li>
                        <span>{window.Translator.getSlug('properlyForGraduade', this.props.language)}:</span>{window.Translator.getSlug('Yes', this.props.language)}
                    </li>}
                    {this.props.data.practise && this.props.data.practise > 0 &&
                    <li>
                        <span>{window.Translator.getSlug('ExperienceYear', this.props.language)}:</span>{this.props.data.practise}
                    </li>}
                    <DateStart language={this.props.language}
                               type={this.props.data.date_start_type}
                               date={this.props.data.date_start}/>
                    {(this.props.data.specialization && this.props.data.specialization.trim().length !== 0) &&
                    <li>
                        <span>{window.Translator.getSlug('Specialization', this.props.language)}:</span>{removeHTMLtags(this.props.data.specialization)}
                    </li> }
                    {(this.props.data.practise_sector && this.props.data.practise_sector.trim().length !== 0) &&
                    <li>
                        <span>{window.Translator.getSlug('ExperienceInSector', this.props.language)}:</span>{this.props.data.practise_sector}
                    </li>}
                    {(this.props.data.region_description && this.props.data.region_description.trim().length !== 0) &&
                    <li>
                        <span>{window.Translator.getSlug('Location', this.props.language)}:</span>{removeHTMLtags(this.props.data.region_description)}
                    </li>}
                    {(this.props.data.salary_text && this.props.data.salary_text.trim().length !== 0) &&
                    <li>
                        <span>{window.Translator.getSlug('OfferedSalary', this.props.language)}:</span>{removeHTMLtags(this.props.data.salary_text)}
                    </li>}
                </ul>
            </div>
        );
    };
}
